import { z, string, object, number, array } from "zod";

const fundManagerSchema = object({
  ManagerId: string(),
  Name: string(),
  Role: string(),
  Display: string(),
  StartDate: string(),
  Tenure: string(),
});

export const fundRiskLevel = z.enum([
  "Low Risk",
  "Low to Moderate Risk",
  "Moderate Risk",
  "Moderately High risk",
  "High Risk",
  "Very High Risk",
]);

export const metricInsightSchema = object({
  text: string(),
  metric_key: string(),
  metric_name: string(),
  metric_value: number(),
  metric_unit: string(),
  score: number(),
});

const rankingMetricsSchema = object({
  manager_tenure: string(),
  ter: string(),
  turnover_ratio: string(),
  relative_return_3yr: string(),
  relative_return_5yr: string(),
  relative_return_10yr: string(),
  rolling_return_3yr: string(),
  rolling_return_5yr: string(),
  rolling_return_10yr: string(),
  sharpe_ratio_3yr: string(),
  sortino_ratio_3yr: string(),
  capture_ratio_downside_3yr: string(),
  capture_ratio_upside_3yr: string(),
  standard_deviation_3yr: string(),
  tracking_error_3yr: string(),
  tracking_error_5yr: string(),
  tracking_error_10yr: string(),
});

export const rankingMetrics = z.enum(rankingMetricsSchema.keyof().options);

export const fundRankingSchema = z
  .object({
    id: number(),
    fund_name: string(),
    fund_id: string(),
    isin: string(),
    amc_code: string(),
    pros: array(metricInsightSchema),
    cons: array(metricInsightSchema),
    fund_category: string(),
    category_rank: number(),
    total_score: string(),
    score_fund_management: string(),
    score_performance: string(),
    score_risk_reward: string(),
    top_fund_management: array(rankingMetrics),
    top_performance: array(rankingMetrics),
    top_risk_reward: array(rankingMetrics),
    updated_at: string(),
    ranking_date: string(),
  })
  .merge(rankingMetricsSchema);

export const fundDefferedLoadsManagerSchema = object({
  fund: string(),
  managers: array(fundManagerSchema),
  deferred_load_additional_details: string(),
  deferred_loads: array(
    object({
      BreakpointUnit: string(),
      HighBreakpoint: string(),
      LowBreakpoint: string(),
      Unit: string(),
      Value: string(),
    })
  ),
});
